module.exports = __webpack_public_path__ + "img/pass.300e68c5.png";